import { Store } from "../redux/store";
import { showWarning, showSuccess } from '../redux/actions/snackbarActions'
import { post, handleErrors, get } from "./requests";
import { URL_BASE } from "./constants";

async function getUsersEmail() {
    const token = Store.getState().authState.loggedUser;
    const payload = await get(`${URL_BASE}/email/users`, null, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });
    return payload.data;
}

async function sendEmail(title, body, toAll, destinations, category, subcategory) {
    const requestBody = {
        title,
        htmlBody: body
    };
    const token = Store.getState().authState.loggedUser;

    if (toAll) {
        const toAllRequest = {
            ...requestBody,
            sendToAllUsers: toAll
        }
        await post(`${URL_BASE}/email`, toAllRequest, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }, (error) => {
            const { status, data } = error;
            handleErrors(status, data);
        });
        Store.dispatch(showSuccess("Email sended successfully!"));
        return;
    }

    if (destinations && destinations.length > 0) {
        const toDestinations = {
            ...requestBody,
            sendToAllUsers: false,
            destinations
        }
        await post(`${URL_BASE}/email`, toDestinations, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }, (error) => {
            const { status, data } = error;
            handleErrors(status, data);
        });

        return;
    }

    if (category || subcategory) {
        const toCategories = {
            ...requestBody,
            sendToAllUsers: false,
            destinations: [],
            filter: {
                category: !subcategory ? category : undefined,
                subcategory
            }
        }
        await post(`${URL_BASE}/email`, toCategories, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }, (error) => {
            const { status, data } = error;
            handleErrors(status, data);
        });
        Store.dispatch(showSuccess("Email sended successfully!"));
        return;
    }

    Store.dispatch(showWarning('Choose a destination'));
    return;
}

async function uploadImage(imageFile) {
    const formData = new FormData();
    formData.append('image', imageFile);
    const token = Store.getState().authState.loggedUser;
    const payload = await post(`${URL_BASE}/email/image`, formData, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }, (error) => {
        const { status, data } = error;
        handleErrors(status, data);
    });

    return payload.data;
}

export default {
    sendEmail,
    uploadImage,
    getUsersEmail
}